import React from 'react';
import MandatEmisApresPaiementComponent
  from '../../../../components/Mouvement/Panel/InformationsRattachement/MandatEmisApresPaiementComponent';
import InformationsRattachementPanel from '../InformationsRattachementPanel';

class MandatEmisApresPaiementPanel extends InformationsRattachementPanel {
  getComponent = function getComponent(
    data: any,
    onChange: any,
    handlePin: any,
  ): React.ReactElement {
    return (
      <MandatEmisApresPaiementComponent
        data={data}
        handlePin={handlePin}
        onChange={onChange}
        panel={this}
      />
    );
  };
}

export default MandatEmisApresPaiementPanel;
